import { render, staticRenderFns } from "./AboutUsCTA.vue?vue&type=template&id=cd1f2e5a"
import script from "./AboutUsCTA.vue?vue&type=script&lang=js"
export * from "./AboutUsCTA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports